module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_more_link_navy-b702963d39f39d7eaf0f9ec0de60d4ee.svg";